export enum EmailTemplateType {
  USER_SIGNUP = 'user_signup',
  EMAIL_VERIFICATION = 'email_verification',
  PASSWORD_RESET = 'password_reset',
  WELCOME = 'welcome',
  INVITATION = 'invitation',
  NOTIFICATION = 'notification',
  CONFIRMATION = 'confirmation',
  REMINDER = 'reminder',
  CUSTOM = 'custom'
}

export enum ComponentCategory {
  HEADER = 'header',
  CONTENT = 'content',
  FOOTER = 'footer',
  ACTION = 'action',
  LAYOUT = 'layout',
  MEDIA = 'media'
}

export enum VariableType {
  TEXT = 'text',
  HTML = 'html',
  COLOR = 'color',
  URL = 'url',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  SELECT = 'select'
}

export enum EditorView {
  TEMPLATES = 'templates',
  EDITOR = 'editor',
  THEMES = 'themes'
}

export enum ComponentAction {
  ADD = 'add',
  REMOVE = 'remove',
  MOVE = 'move',
  EDIT = 'edit',
  DUPLICATE = 'duplicate'
}
